import React from 'react';
import FacebookPageEmbed from './FacebookPageEmbed.jsx';
import { appContext } from '../../util/decorators';

@appContext
export default class FollowFacebook extends React.PureComponent {
  static propTypes = {
    links: React.PropTypes.array,
  };

  render() {
    const t = this.context.app.t;

    const facebookButtons = this.props.links.map((link) => {
      return (
        <li key={link.name}>
          <FacebookPageEmbed title={link.title} name={link.name} />
        </li>
      );
    });

    return (
      <div className="follow follow-facebook">
        <div className="follow-head">
          <div className="follow-title">
            <span className="icon-container facebook">
              <i className="icon-facebook"></i>
            </span>
            {t('FollowFacebook.social_blurb')}
          </div>
        </div>

        <h2>{t('FollowFacebook.heading')}</h2>

        <div className="inner">
          <ul>
            {facebookButtons}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/FollowFacebook.jsx